import React, { useState } from 'react';
import {
  HistoricoAltura,
} from './HistoricoStyles';
import { HistoricoProcesso } from '../../../components/UI/HistoricoProcesso/HistoricoProcesso';
import { inspecionarProcessoPageController as controller } from '../inspecaoProcessoController';

function DialogExpandirHistorico({
  historicos: historicosIniciais,
  showLoading,
  idProcesso,
}) {
  const [historicos, setHistoricos] = useState(historicosIniciais);
  const [loadingLocal, setLoadingLocal] = useState(false);

  async function addNextHistoricos() {
    setLoadingLocal(true);
    setHistoricos(await controller.findHistoricoWhenScrolled(idProcesso, historicos));
    setLoadingLocal(false);
  }

  return (
    <HistoricoAltura>
      <HistoricoProcesso
        historicos={historicos}
        addNextHistoricos={addNextHistoricos}
        showLoading={showLoading || loadingLocal}
        isDisbaledChangePin
        height={512}
        onChangeChecked={() => {}}
      />
    </HistoricoAltura>
  );
}

export default DialogExpandirHistorico;
